/**
 * Remembers that this sign-in already read the person's saved Open in Claude Code default.
 * A leaf module with NO imports: the auth store clears it on logout, and importing the composable
 * instead would pull in tattle-http and the interceptors, which import the auth store back.
 */
let savedDefaultRead: Promise<void> | null = null

export function readSavedDefaultOnce(read: () => Promise<void>): void {
  savedDefaultRead ??= read()
}

/** Logout keeps the page, so the next person to sign in gets their own saved default read. */
export function forgetSavedOpenDefault(): void {
  savedDefaultRead = null
}
